module.exports = __webpack_public_path__ + "img/报导img.2080ab2b.jpg";